module.exports = __webpack_public_path__ + "img/flashbang_assist.2626a178.svg";